export default __webpack_public_path__ + "static/media/arc-circle-white-beta.18987e5b.svg";